export default "__VITE_ASSET__ef228125__"